module.exports = __webpack_public_path__ + "res/img_top_center_rtl.f6de627bc132b03c9a4381fe065ece78.png";